<div mat-dialog-title class="!text-base">{{title}}</div>
<div mat-dialog-content class="py-0">
    <form [formGroup]="myForm" class="grid gap-y-2">
        <mat-form-field class="w-full">
            <mat-label>Categoría principal </mat-label>
            <mat-select formControlName="idCategoriaPadre">
                <!-- <mat-option>Ninguno</mat-option> -->
                <mat-option *ngFor="let c of categorias" [value]="c.id">{{c.descripcion}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="w-full">
            <mat-label>Categoría</mat-label>
            <input matInput type="text" autocomplete="off" formControlName="descripcion" required>
            <mat-error>
                Completa este campo.
            </mat-error>
        </mat-form-field>
    </form>
</div>

<div mat-dialog-actions align="end" class="!px-6">
    <button mat-stroked-button color="primary" class="me-4" mat-dialog-close type="button">Cancelar</button>
    <adp-button-icon (clicked)="onSubmit()" color="primary" [disabled]="myForm.invalid" [loading]="loading"
        label="Guardar"></adp-button-icon>
</div>